import { render, staticRenderFns } from "./DocumentFileUpload.vue?vue&type=template&id=2530e2a4&scoped=true&"
import script from "./DocumentFileUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFileUpload.vue?vue&type=style&index=0&id=2530e2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530e2a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
